import { api } from "@/lib/api-client"

export interface SegmentAnalysisCostProtection {
  enabled: boolean
  currency: string
  monthlyCeiling: number
  perRunTokenCap: number
  blockManualOnCeiling: boolean
}

export interface SegmentAnalysisScheduling {
  enabled: boolean
  mode: "partial" | "full"
}

export interface SegmentAnalysisAutoApproval {
  enabled: boolean
  numericTolerancePct: number
  allowDateOnly: boolean
  allowSourceListOnly: boolean
}

export interface SegmentAnalysisNotifications {
  inApp: boolean
  email: boolean
  teams: boolean
  emailRecipients: string[]
}

export interface SegmentAnalysisAddressableLine {
  key: string
  label: string
  sublabel?: string
}

export interface SegmentAnalysisPresentation {
  addressableLines: SegmentAnalysisAddressableLine[]
}

export interface SegmentAnalysisConfig {
  costProtection: SegmentAnalysisCostProtection
  scheduling: SegmentAnalysisScheduling
  autoApproval: SegmentAnalysisAutoApproval
  notifications: SegmentAnalysisNotifications
  presentation: SegmentAnalysisPresentation
}

export async function getSegmentAnalysisConfig(): Promise<SegmentAnalysisConfig> {
  const response = await api.get("/admin/segment-analysis/config")
  return (response.data || response).config
}

export async function updateSegmentAnalysisConfig(
  config: SegmentAnalysisConfig
): Promise<SegmentAnalysisConfig> {
  const response = await api.put("/admin/segment-analysis/config", { config })
  return (response.data || response).config
}
